<div class="role" [ngClass]="{ closed: isCollapsed }">
  <div class="toggle" aria-controls="collapse">
    <div
      class="toggle-left"
      [attr.aria-expanded]="!isCollapsed"
      (click)="isCollapsed = !isCollapsed"
      (keydown.enter)="isCollapsed = !isCollapsed"
      tabindex="1">
      <img [ngClass]="{ chevron: true, open: !isCollapsed }" src="assets/images/chevron-icon.svg" alt="arrow" />
      <h5>
        {{ isSystemRoles ? ('pages.role.systemRoles' | translate) : ('pages.role.structuralUnitRoles' | translate) }}
      </h5>
    </div>
  </div>
  <div id="collapseExample" [ngbCollapse]="isCollapsed">
    @for (role of roles; track role) {
      <div class="item-wrapper">
        <div class="item">
          <p class="item-name">{{ role.name }}</p>
          <div class="item-actions">
            @if (role.canEdit) {
              <button class="edit" [policyType]="CLAIM_SCOPE" [claimType]="CLAIM_TYPES['update']" (click)="onEdit(role.id)" appPermission>
                <img src="assets/images/edit-icon.svg" alt="edit" />
                {{ 'pages.role.edit' | translate }}
              </button>
            } @else {
              <button class="view" (click)="onView(role.id)">
                <img src="assets/images/view-icon.svg" alt="view" />
                {{ 'pages.role.view' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
